import { connect } from 'react-redux';
import CompanyList from '../components/CompanyList/CompanyList';
import * as actions from '../actions/companyActionCreators';

const mapStateToProps = (state) => ({ companies: state.companies });

export default connect(mapStateToProps, actions)(CompanyList);
